/* eslint-disable no-process-env */

const isTrue = (t?: string | boolean) => t === true || t === 'true'

/**
 * These variables are populated at runtime and are accessible for both server and client
 */

type TRuntimeConfigs = {
  IS_PROD: boolean
  TRIBE_GQL_ENDPOINT: string
  TRIBE_APP_DOMAIN: string
  FORCED_NETWORK_DOMAIN: string
  SSOS_CALLBACK_URL: string
  UNSPLASH_ACCESS_KEY: string
  GIPHY_API_KEY: string
  INTERCOM_APP_ID: string
  SNOWPLOW_COLLECTOR_ADDRESS: string
  SNOWPLOW_ENABLE_PAGE_PING: boolean
  SNOWPLOW_ENABLE_PAGE_VIEW: boolean
  NODE_ENV: string
  FULLSTORY_ORGANIZATION_ID: string
  FULLSTORY_DEBUG_MODE: boolean
  RELEASE_CHANNEL: string
  SENTRY_DSN: string
  OPTIMIZELY_SDK_KEY: string
  CLIENT_LOG_LEVEL: string
  SUPPORT_COMMUNITY_URL: string
  DD_ENABLED: boolean
  DD_RUM_APP_ID: string
  DD_RUM_CLIENT_TOKEN: string
  DD_RUM_SERVICE_NAME: string
  DD_PROFILER_ENABLED: boolean
  DD_RUM_SAMPLE_RATE: number
}

export const RuntimeConfigs: TRuntimeConfigs = (env => {
  return {
    IS_PROD: env.NODE_ENV === 'production',
    TRIBE_GQL_ENDPOINT: env.TRIBE_GQL_ENDPOINT,
    TRIBE_APP_DOMAIN: env.TRIBE_APP_DOMAIN,
    FORCED_NETWORK_DOMAIN: env.FORCED_NETWORK_DOMAIN,
    SSOS_CALLBACK_URL: env.SSOS_CALLBACK_URL,
    UNSPLASH_ACCESS_KEY: env.UNSPLASH_ACCESS_KEY,
    GIPHY_API_KEY: env.GIPHY_API_KEY,
    INTERCOM_APP_ID: env.INTERCOM_APP_ID,
    SNOWPLOW_COLLECTOR_ADDRESS: env.SNOWPLOW_COLLECTOR_ADDRESS,
    SNOWPLOW_ENABLE_PAGE_PING: isTrue(env.SNOWPLOW_ENABLE_PAGE_PING),
    SNOWPLOW_ENABLE_PAGE_VIEW: isTrue(env.SNOWPLOW_ENABLE_PAGE_VIEW),
    NODE_ENV: env.NODE_ENV,
    FULLSTORY_ORGANIZATION_ID: env.FULLSTORY_ORGANIZATION_ID,
    FULLSTORY_DEBUG_MODE: isTrue(env.FULLSTORY_DEBUG_MODE),
    RELEASE_CHANNEL: env.RELEASE_CHANNEL,
    SENTRY_DSN: env.SENTRY_DSN,
    OPTIMIZELY_SDK_KEY: env.OPTIMIZELY_SDK_KEY,
    CLIENT_LOG_LEVEL: env.CLIENT_LOG_LEVEL || 'info',
    SUPPORT_COMMUNITY_URL: env.SUPPORT_COMMUNITY_URL,
    DD_ENABLED: isTrue(env.DD_ENABLED),
    DD_RUM_APP_ID: env.DD_RUM_APP_ID,
    DD_RUM_CLIENT_TOKEN: env.DD_RUM_CLIENT_TOKEN,
    DD_RUM_SERVICE_NAME: env.DD_RUM_SERVICE_NAME,
    DD_PROFILER_ENABLED: isTrue(env.DD_PROFILER_ENABLED),
    DD_RUM_SAMPLE_RATE: parseInt(`${env.DD_RUM_SAMPLE_RATE || 0}`, 10),
  }
})(typeof window !== 'undefined' ? window.RuntimeConfigs : process.env)

declare global {
  interface Window {
    RuntimeConfigs: {
      [K in keyof TRuntimeConfigs]: string
    }
  }
}
